import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Bell, FileClock, ReceiptEuro } from "lucide-react";
import api from "@/lib/api";
import { fmtDate } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

// Header bell listing quotes/invoices expiring within 7 days (in-app reminders).
export default function NotificationBell() {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();

  const load = useCallback(() => {
    api.get("/notifications?days=7").then((r) => setItems(r.data.items || [])).catch(() => {});
  }, []);
  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, [load]);

  const count = items.length;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="icon" className="relative text-muted-foreground" data-testid="notifications-bell">
          <Bell className="w-[18px] h-[18px]" />
          {count > 0 && (
            <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-primary text-primary-foreground text-[10px] font-bold flex items-center justify-center" data-testid="notifications-badge">
              {count}
            </span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0" data-testid="notifications-panel">
        <div className="px-4 py-3 border-b border-border font-heading font-semibold text-sm">Promemoria scadenze</div>
        <div className="max-h-80 overflow-y-auto divide-y divide-border">
          {items.map((n) => (
            <button
              key={n.id}
              onClick={() => navigate(n.link)}
              className="w-full text-left px-4 py-3 hover:bg-secondary/50 flex items-start gap-3"
              data-testid={`notification-${n.id}`}
            >
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center shrink-0 ${n.type === "fattura" ? "bg-emerald-50 text-emerald-600 dark:bg-emerald-950/50 dark:text-emerald-400" : "bg-primary/10 text-primary"}`}>
                {n.type === "fattura" ? <ReceiptEuro className="w-4 h-4" /> : <FileClock className="w-4 h-4" />}
              </div>
              <div className="min-w-0 flex-1">
                <div className="text-sm font-medium truncate">{n.title}</div>
                <div className="text-xs text-muted-foreground truncate">{n.sub || "—"}</div>
                <div className={`text-xs font-medium mt-0.5 ${n.overdue ? "text-rose-600 dark:text-rose-400" : "text-amber-600 dark:text-amber-400"}`}>
                  {n.overdue ? `Scaduto il ${fmtDate(n.date)}` : n.days_left === 0 ? "Scade oggi" : `Scade tra ${n.days_left} gg · ${fmtDate(n.date)}`}
                </div>
              </div>
            </button>
          ))}
          {count === 0 && <div className="px-4 py-8 text-center text-sm text-muted-foreground">Nessuna scadenza nei prossimi 7 giorni.</div>}
        </div>
      </PopoverContent>
    </Popover>
  );
}
